__turbopack_context__.v({
  "banner": "AppDownloadBannerV2-module-scss-module__mTLYkq__banner",
  "bannerImage": "AppDownloadBannerV2-module-scss-module__mTLYkq__bannerImage",
  "container": "AppDownloadBannerV2-module-scss-module__mTLYkq__container",
  "content": "AppDownloadBannerV2-module-scss-module__mTLYkq__content",
  "eyebrow": "AppDownloadBannerV2-module-scss-module__mTLYkq__eyebrow",
  "hpv2Blink": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2Blink",
  "hpv2DemoBounce": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2DemoBounce",
  "hpv2DemoFadeIn": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2DemoFadeIn",
  "hpv2DemoProgress": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2DemoProgress",
  "hpv2DemoScaleIn": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2DemoSlideIn",
  "hpv2FadeLeft": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2FadeLeft",
  "hpv2FadeRight": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2FadeRight",
  "hpv2FadeUp": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2FadeUp",
  "hpv2FloatA": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2FloatA",
  "hpv2FloatB": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2FloatB",
  "hpv2HeroFadeIn": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2PriceShimmer",
  "hpv2PulseDot": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2PulseDot",
  "hpv2ScaleUp": "AppDownloadBannerV2-module-scss-module__mTLYkq__hpv2ScaleUp",
  "imageCol": "AppDownloadBannerV2-module-scss-module__mTLYkq__imageCol",
  "stat": "AppDownloadBannerV2-module-scss-module__mTLYkq__stat",
  "statDivider": "AppDownloadBannerV2-module-scss-module__mTLYkq__statDivider",
  "statLabel": "AppDownloadBannerV2-module-scss-module__mTLYkq__statLabel",
  "statValue": "AppDownloadBannerV2-module-scss-module__mTLYkq__statValue",
  "stats": "AppDownloadBannerV2-module-scss-module__mTLYkq__stats",
  "storeButton": "AppDownloadBannerV2-module-scss-module__mTLYkq__storeButton",
  "storeButtons": "AppDownloadBannerV2-module-scss-module__mTLYkq__storeButtons",
  "storeIcon": "AppDownloadBannerV2-module-scss-module__mTLYkq__storeIcon",
  "storeLabel": "AppDownloadBannerV2-module-scss-module__mTLYkq__storeLabel",
  "storeName": "AppDownloadBannerV2-module-scss-module__mTLYkq__storeName",
  "storeText": "AppDownloadBannerV2-module-scss-module__mTLYkq__storeText",
  "subtitle": "AppDownloadBannerV2-module-scss-module__mTLYkq__subtitle",
  "title": "AppDownloadBannerV2-module-scss-module__mTLYkq__title",
  "titleLine": "AppDownloadBannerV2-module-scss-module__mTLYkq__titleLine",
});
